import React from 'react'
import { Box, Typography, IconButton } from '@mui/material'
import { useTranslation } from 'react-i18next'

const IndoorUnavailableModal = ({ lastSeen, onClose }) => {
  const { t, i18n } = useTranslation()

  const formatDate = (dateString) => {
    if (!dateString) return '?'
    const date = new Date(dateString)
    return date.toLocaleDateString(i18n.language)
  }

  const formatTime = (dateString) => {
    if (!dateString) return '?'
    const date = new Date(dateString)
    return date.toLocaleTimeString(i18n.language, { hour: '2-digit', minute: '2-digit' })
  }

  return (
    <Box
      onClick={(e) => e.stopPropagation()}
      sx={{
        backgroundColor: 'white',
        borderRadius: '16px',
        padding: '24px',
        maxWidth: '400px',
        width: '90%',
        boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.15)',
        position: 'relative',
        zIndex: 100
      }}
    >
      <IconButton
        onClick={onClose}
        sx={{
          position: 'absolute',
          top: '12px',
          right: '12px',
          width: '24px',
          height: '24px',
          color: '#7A8096',
          '&:hover': {
            backgroundColor: '#F6F7F8'
          }
        }}
      >
        <i className="fa-light fa-xmark" style={{ fontSize: '16px' }} />
      </IconButton>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px', alignItems: 'center' }}>
        <Box
          sx={{
            width: '48px',
            height: '48px',
            borderRadius: '50%',
            backgroundColor: '#FEF2F2',
            border: '2px solid #FEE2E2',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <i className="fa-light fa-warning" style={{ fontSize: '16px', color: '#DC2626' }} />
        </Box>

        <Typography
          sx={{
            fontSize: '20px',
            fontWeight: 600,
            color: '#DC2626',
            textAlign: 'center'
          }}
        >
          {t('supervision.site_down_modal.title')}
        </Typography>

        <Box sx={{ textAlign: 'center' }}>
          <Typography
            sx={{
              fontSize: '14px',
              fontWeight: 400,
              color: '#5D5F70',
              lineHeight: '20px'
            }}
          >
            {t('supervision.site_down_modal.since', {
              date: formatDate(lastSeen),
              time: formatTime(lastSeen)
            })}
          </Typography>
          <Typography
            sx={{
              fontSize: '14px',
              fontWeight: 400,
              color: '#5D5F70',
              lineHeight: '20px'
            }}
          >
            {t('supervision.site_down_modal.unavailable')}
          </Typography>
          <Typography
            sx={{
              fontSize: '14px',
              fontWeight: 400,
              color: '#5D5F70',
              lineHeight: '20px'
            }}
          >
            {t('supervision.site_down_modal.impacted')}
          </Typography>
        </Box>
      </Box>
    </Box>
  )
}

export default IndoorUnavailableModal